import { render, staticRenderFns } from "./ActivityStyle.vue?vue&type=template&id=1f63173e&scoped=true"
import script from "./ActivityStyle.vue?vue&type=script&lang=js"
export * from "./ActivityStyle.vue?vue&type=script&lang=js"
import style0 from "./ActivityStyle.vue?vue&type=style&index=0&id=1f63173e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f63173e",
  null
  
)

export default component.exports